import { gatewayJsdk } from '../../../configurations/configuration.json';

let crrClsIframeOpts;
let shopPos;

const shoppingCartCustomPos = [
    {
        posId: 'pos_4',
        placeBtn: (btnEle) => {
            const wrappEle = btnEle.parentElement;
            wrappEle.insertBefore(btnEle, wrappEle.firstElementChild);
        }
    },
    {
        posId: 'pos_5',
        placeBtn: (btnEle) => {
            const wrappEle = btnEle.parentElement;
            btnEle.classList.add('btnCl--right');
            wrappEle.insertBefore(btnEle, wrappEle.firstElementChild);
        }
    },
];


export const registerBtnCustomPositioning = (crrPosVal) => {
    if (!shopPos) shopPos = crrPosVal;
    const btnRefs = [...document.querySelectorAll('#cls-button-wrapp')];
    btnRefs.forEach(btnEle => {
        let btnCustomPos = shoppingCartCustomPos.filter(({ posId }) => posId === crrPosVal);
        if (btnCustomPos.length) {
            btnCustomPos = btnCustomPos.pop();
            btnCustomPos.placeBtn(btnEle);
            // console.log([...document.querySelectorAll(`#clk-button`)]);
        }
    });
}


export const renderBtnsManually = (blueprint, btnPosPriority) => {
    const getClsTag = () => document.querySelector('clk-button');
    const getRenderCb = (pos) => ({
        '10': () => {
            let wrapp = [...document.querySelectorAll(".price-wrapper")].shift();
            wrapp.innerHTML = btnsBluePrintTag + wrapp.innerHTML
        },
        '15': () => [...document.querySelectorAll(".price-wrapper")].shift().innerHTML += btnsBluePrintTag,
        '30': () => {
            let wrapp = [...document.querySelectorAll('form[class*=cart]')].pop();
            (wrapp && (wrapp.innerHTML = btnsBluePrintTag + wrapp.innerHTML)) || getRenderCb(10);
        },
        '40': () => {
            let wrapp = [...document.querySelectorAll('form[class*=cart]')].pop();
            (wrapp && (wrapp.innerHTML += btnsBluePrintTag)) || getRenderCb(10);;
        }
    })[pos]();
    const prodBtnInter = setInterval(async () => {
        console.log("%cCLS button was rendered manually", "background: #1982b7;");
        if (!getClsTag()) {
            const priceWrapp = [...document.querySelectorAll(".price-wrapper")].shift();
            if (priceWrapp) {
                console.log(btnPosPriority);
                getRenderCb(btnPosPriority || 15);
                clearInterval(prodBtnInter);
                const scriptFetched = await attachRenderBtnsScript('cls-render-button', `${gatewayJsdk}/static/js/build/cls-jsdk-script.bundle.js`)
                if (!scriptFetched) return;
                clsGlobalObj.registerClsBtnFuncionality();
            }
        }
    }, 1100);
}
export const importIframeEvents = function () {
    const attachScript = () => {
        const iframsJsId = 'cls-iframe-events-script';
        const iframeScript = document.querySelector(`#${iframsJsId}`);
        if (iframeScript) iframeScript.remove();
        const s = document.createElement('script');
        s.src = `${gatewayJsdk}/static/js/build/cls-iframe-events.bundle.js`;
        s.id = iframsJsId;
        document.body.appendChild(s);
    }
    jQuery(document.body).on('updated_cart_totals', function () {
        const tag = () => document.querySelector('clk-button');
        const clsBtn = () => document.querySelector('#cls-btn');
        // if (tag())
        if (clsBtn()) {
            const newPrice = [...document.querySelectorAll('.cart_totals .woocommerce-Price-amount')]?.pop()?.textContent.replaceAll(/^\D/g, '');
            if (newPrice) {
                clsGlobalObj.blueprintTag.setAttribute('price', '10000')
                clsGlobalObj.blueprintTag.price = '10000';
            }
            clsBtn().insertAdjacentElement('afterend', clsGlobalObj.blueprintTag);
            clsBtn().remove();
        }
        attachRenderBtnsScript('cls-render-button', `${gatewayJsdk}/static/js/build/cls-jsdk-script.bundle.js`)
            .then(res => {
                registerClsBtnFuncionality();
                clsGlobalObj.registerBtnCustomPositioning(shopPos);
            });
        console.log('%cCART_UPDATED', 'background: blue;');
    });
    jQuery(document.body).on('update_checkout', function () {
        console.log('%cCHECKOUT_UPDATED', 'background: blue;');
    });
    attachScript();
}

export function registerClsBtnFuncionality(clsBtnEle) {
    if (!clsBtnEle) clsBtnEle = document.querySelectorAll('#cls-btn');
    if ((!clsBtnEle[0] instanceof HTMLButtonElement)) return;
    clsBtnEle.forEach(btn => btn.addEventListener('click', (e) => e.preventDefault()));
}

export const attachRenderBtnsScript = (sId, path) =>
    new Promise((res, rej) => {
        const iframsJsId = sId;
        const iframeScript = document.querySelector(`#${iframsJsId}`);
        if (iframeScript) iframeScript.remove();
        const s = document.createElement('script');
        s.src = path;
        s.id = iframsJsId;
        document.body.appendChild(s);
        s.onload = () => {
            const isClsBtnThere = setInterval(() => {
                if (document.querySelector('#cls-btn')) {
                    res(true);
                    clearInterval(isClsBtnThere);
                    document.querySelector(`#${sId}`);
                }
            }, 700);
            setTimeout(() => {
                clearInterval(isClsBtnThere);
                rej(false);
            }, 20 * 1000)
        }
    });

